function shareHandler(event) {
    const width = parseFloat(event.currentTarget.dataset.popupWidth);
    const height = parseFloat(event.currentTarget.dataset.popupHeight);
    const left = screen.width / 2 - width / 2;
    const top = screen.height / 2 - height / 2;

    const options = `toolbar=0, status=0, width=${width}, height=${height}, left=${left}, top=${top}`;

    const popup = open(event.currentTarget.href, event.currentTarget.target, options);

    // If Safari's popup blocker kicked in, `popup` will be null.
    // Only stop the link action if the popup exists.
    // Otherwise let the link behave normally.
    if (popup) {
        event.preventDefault();
    }
};

const DEFAULTS = {
    url: location.protocol + '//' + location.host + location.pathname,
    text: document.title,
    width: 550,
    height: 450
};

function setSharingAttributes(hrefTemplate, element, binding) {
    const url = binding.value && binding.value.url ? binding.value.url : DEFAULTS.url;
    const text = binding.value && binding.value.text ? binding.value.text : DEFAULTS.text;
    const width = binding.value && binding.value.width ? binding.value.width : DEFAULTS.width;
    const height = binding.value && binding.value.height ? binding.value.height : DEFAULTS.height;
    element.href = hrefTemplate({ url, text });
    element.target = '_blank';
    element.rel = 'noopener';
    element.dataset.popupWidth = width;
    element.dataset.popupHeight = height;
    // Set `onclick` directly to avoid having to tear down on unmount.
    element.onclick = shareHandler;
}

export const shareOnFacebook = setSharingAttributes.bind(null, function({ url }) {
    return `http://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`;
});

export const shareOnTwitter = setSharingAttributes.bind(null, function({ url, text }) {
    return `http://twitter.com/share?url=${encodeURIComponent(url)}&amp;text=${encodeURIComponent(text)}&amp;related=crowdpac`;
});
